export default __webpack_public_path__ + "static/media/TeleHealth Omnichannel.cbbd1550.jpg";